export default __webpack_public_path__ + "8061c02a7291f35015d014eaed8b7e7d.png";